import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useFormik } from "formik";
import { emailValidate, passwordValidate } from "../helper/validate";
import { useAuthStore } from "../store/store";
import { verifyPassword } from "../helper/helper";

export default function Login() {
  const navigate = useNavigate();
  const setEmail = useAuthStore((state) => state.setEmail);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate: async (values) => {
      const errors = {};
      const emailErrors = await emailValidate(values);
      const passwordErrors = await passwordValidate(values);
      Object.assign(errors, emailErrors, passwordErrors);
      return errors;
    },
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      setEmail(values.email);
      let loginPromise = verifyPassword({ email: values.email, password: values.password });
      loginPromise.then((res) => {
        let { token } = res.data;
        localStorage.setItem("token", token);
        navigate("/Dashboard");
      });
    },
  });

  return (
    <div className="flex flex-col bg-white min-h-screen">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="flex flex-grow items-center justify-center px-4">
        <div className="w-full max-w-sm bg-white shadow-lg rounded-lg p-6">
          <h1 className="text-2xl font-bold text-center mb-6">Log In</h1>
          <form className="w-full" onSubmit={formik.handleSubmit}>
            <input
              {...formik.getFieldProps("email")}
              className="w-full p-3 border rounded-lg mb-4"
              type="email"
              placeholder="Email"
              autoComplete="username"
            />
            <input
              {...formik.getFieldProps("password")}
              className="w-full p-3 border rounded-lg mb-4"
              type="password"
              placeholder="Password"
              autoComplete="email"
            />
            <button className="w-full bg-red-500 text-white p-3 rounded-lg hover:bg-red-600" type="submit">
              Log in
            </button>
          </form>

          <div className="text-center py-4">
            <span className="text-gray-500">
              Don't have an account?{" "}
              <Link className="text-red-500" to="/">
                Try for Free
              </Link>
            </span>
          </div>

          <div className="text-center">
            <Link className="text-sm text-red-500 hover:underline" to="/recovery">
              Forgot Password?
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}



